/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Stripe_Publishable_KeyInputs */

const en_admin_settings_fields_stripe_publishable_key = /** @type {(inputs: Admin_Settings_Fields_Stripe_Publishable_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publishable Key`)
};

const zh_admin_settings_fields_stripe_publishable_key = /** @type {(inputs: Admin_Settings_Fields_Stripe_Publishable_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公钥`)
};

/**
* | output |
* | --- |
* | "Publishable Key" |
*
* @param {Admin_Settings_Fields_Stripe_Publishable_KeyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_stripe_publishable_key = /** @type {((inputs?: Admin_Settings_Fields_Stripe_Publishable_KeyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Stripe_Publishable_KeyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_stripe_publishable_key(inputs)
	return zh_admin_settings_fields_stripe_publishable_key(inputs)
});
export { admin_settings_fields_stripe_publishable_key as "admin.settings.fields.stripe_publishable_key" }